export default "__VITE_ASSET__186f939c__"